import { IconCompass } from "@tabler/icons-react";
import { Footer } from "../components/Footer";
import { useSession } from "../session";

export function NotFoundPage() {
  const { t } = useSession();
  return (
    <div className="page page-center">
      <main className="centered">
        <IconCompass size={40} stroke={1.25} className="muted" />
        <h1>{t("notFoundTitle")}</h1>
        <p className="muted">{t("notFoundBody")}</p>
        <a href="/" className="button button-primary">
          {t("goHome")}
        </a>
      </main>
      <Footer />
    </div>
  );
}

/** The API host serves no brand: point to the brands' own areas. */
export function NoBrandPage() {
  const { brandInfo, t } = useSession();
  return (
    <div className="page page-center">
      <main className="centered">
        <h1>{t("chooseBrand")}</h1>
        <p className="muted">{t("chooseBrandBody")}</p>
        <div className="stack brand-list">
          {(brandInfo?.brands ?? []).map((b) => (
            <a key={b.code} href={b.origin} className="card card-link brand-link" rel="external">
              <strong>{b.name}</strong>
              <span className="muted small">{b.origin.replace(/^https?:\/\//, "")}</span>
            </a>
          ))}
        </div>
      </main>
    </div>
  );
}
